
import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    SortBox: () => import("@/components/SortBox.vue"),
    Slick: () => import("vue-slick")
  }
})
export default class UsersIndex extends Vue {
  currencies: any = [];
  currency: any = {};
  exchanges: any = {};
  error: boolean = false;
  error2: boolean = false;
  exchangesDate: Record<string, any> = {};
  sortColumns: Record<string, string> = {
    0: "Actualizar Paridad Cambiaria capacidad máxima de riesgo",
    1: "Nueva Moneda",
    2: "Historial de cambios"
  };
  slickOptions: Record<string, any> = {
    slidesToShow: 2,
    centerPadding: 0,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false
        }
      }
    ]
  };
  isMobile: boolean = window.innerWidth < 992;
  firstLoad: boolean = true;

  @Watch("isMobile")
  onIsMobileChange(val: boolean, old: boolean) {
    if (this.firstLoad && old === true) {
      this.firstLoad = false;
    } else {
      location.reload();
    }
  }

  handleAfterChange(event, slick, currentSlide) {
    (this.$refs.sortBox as any).update(currentSlide);
  }

  init() {
    this.loadCurrencies();
    this.loadExchanges();
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 992;
    });
  }

  async updateExchanges() {
    let keys: any[] = Object.keys(this.exchanges);
    for (let i: number = 0; i < keys.length; i++) {
      try {
        await (this.$root as any)._post("exchangeraterisks", {
          currencyId: this.exchanges[keys[i]].currency.id,
          value: this.exchanges[keys[i]].value
        });
        (this.$root as any).notify("Se realizo la actualización con éxito.");
      } catch (e) {
        (this.$root as any).notify(
          "No se pudo actualizar el tipo de cambio.",
          "error"
        );
      }
    }
    location.reload();
  }

  async saveCurrency() {
    if (!this.currency.title) {
      this.error = true;
      return;
    }
    if (!this.currency.description) {
      this.error2 = true;
      return;
    }
    try {
      await (this.$root as any)._post("currencies", this.currency);
      (this.$root as any).notify("Se creo la moneda con éxito.");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (e) {
      (this.$root as any).notify("No se pudo crear la moneda.", "error");
    }
  }

  move(index) {
    (this.$refs.slick as any).goTo(index);
  }

  lastExchange() {
    if (Object.keys(this.exchangesDate).length > 0) {
      return this.exchangesDate[Object.keys(this.exchangesDate).pop()];
    }
  }

  async loadExchanges() {
    const response: any = await (this.$root as any)._get(
      "exchangeraterisks/all",
      { getFullList: true }
    );
    let exchangesDate = {};
    response.data.forEach((risk: any) => {
      let riskDate: string = moment(risk.createdAt).format("DD-MM-YYYY");
      if (!exchangesDate[riskDate]) {
        exchangesDate[riskDate] = {};
        this.currencies.forEach((currency: any) => {
          exchangesDate[riskDate][currency.title] = {
            value: 0,
            currency: {
              ...currency
            }
          };
        });
      }
      exchangesDate[riskDate][risk.currency.title] = risk;
    });
    this.exchangesDate = exchangesDate;
    this.exchanges = this.lastExchange();
  }

  async loadCurrencies() {
    const response: any = await (this.$root as any)._get("currencies/all");
    this.currencies = response.data;
  }
}
